<template>
  <v-btn rounded depressed @click="$router.go(-1)" text> <v-icon size="19" left>mdi-arrow-left</v-icon> Voltar</v-btn>
</template>

<script>
export default {

}
</script>

<style>

</style>